// extracted by mini-css-extract-plugin
export default {"globalLoader":"GlobalLoader_globalLoader__mj8we","smooothpulse":"GlobalLoader_smooothpulse__OYiiZ"};